import { motion, AnimatePresence } from 'framer-motion';
import PropTypes from 'prop-types';

const PageTransition = ({ isAnimating, onAnimationComplete, duration }) => {
  const sweepVariants = {
    initial: { x: '-120%', opacity: 0 },
    animate: {
      x: ['-120%', '0%', '120%'],
      opacity: [0, 1, 0],
      transition: {
        duration,
        ease: [0.25, 0.46, 0.45, 0.94]
      }
    },
    exit: { opacity: 0 }
  };

  const logoVariants = {
    initial: { opacity: 0, scale: 0.9, y: 10 },
    animate: {
      opacity: [0, 1, 0],
      scale: [0.9, 1.02, 1],
      y: [10, 0, -6],
      transition: {
        duration,
        ease: 'easeOut'
      }
    },
    exit: { opacity: 0 }
  };

  return (
    <AnimatePresence mode='wait'>
      {isAnimating && (
        <motion.div
          key='sentinel-transition'
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            zIndex: 9999,
            pointerEvents: 'all',
            overflow: 'hidden',
            background: 'linear-gradient(135deg, #0f0146 0%, #8309fe 55%, #a940ff 70%, #d2a8ff 100%)'
          }}
          onAnimationComplete={() => {
            setTimeout(() => {
              onAnimationComplete('exit');
            }, duration * 1000 + 200);
          }}
        >
          {/* Sweep bar */}
          <motion.div
            variants={sweepVariants}
            initial='initial'
            animate='animate'
            exit='exit'
            style={{
              position: 'absolute',
              top: '50%',
              left: 0,
              width: '40vw',
              height: '12vh',
              transform: 'translateY(-50%)',
              background: 'linear-gradient(90deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.3) 50%, rgba(255,255,255,0.05) 100%)',
              filter: 'blur(8px)'
            }}
          />

          {/* Sentinel logo */}
          <motion.img
            variants={logoVariants}
            initial='initial'
            animate='animate'
            exit='exit'
            src={'/logos/sentinel-white-logo.svg'}
            alt='Sentinel Logo'
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '40vw',
              maxWidth: '620px',
              height: 'auto',
              filter: 'drop-shadow(0 14px 40px rgba(0,0,0,0.25))'
            }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

PageTransition.propTypes = {
  isAnimating: PropTypes.bool.isRequired,
  onAnimationComplete: PropTypes.func.isRequired,
  duration: PropTypes.number.isRequired
};

export default PageTransition;
